import React, { useCallback, useEffect, useRef, useState } from 'react'
import Deal from '../../components/deal'
import LoadingIndicator from '../../components/loadingIndicator'
import NoDealsInfo from '../../components/noDealsInfo'
import Text from '../../components/text'
import { useAxios } from '../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import useDealsToDisplay from '../../customhooks/useDealsToDisplay'
import { fetchWalletAction } from '../financier/FinancierDuck'
import * as styles from './Deals.css'
import { LiquidationPolicy } from '../../components/liquidationPolicy/LiquidationPolicy'

export const Deals = () => {
  const [noDealsCurrently, setNoDealsCurrently] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [dealFetchType, setDealFetchType] = useState('primary')

  const { authAxios } = useAxios()
  const {
    financierState,
    dealsState: { query },
  } = useGlobal()
  const { financierDispatch } = useGlobalDispatch()
  const observer = useRef()

  const { deals, hasMore, loading, error } = useDealsToDisplay(query, pageNumber, dealFetchType)

  useEffect(() => {
    // When all primaries are loaded set to load secondary deal and reset page number
    if (dealFetchType === 'primary' && !hasMore && !loading) {
      setDealFetchType('secondary')
      setPageNumber(1)
    }
  }, [dealFetchType, hasMore, loading])

  useEffect(() => {
    // On query change reset all
    setDealFetchType('primary')
    setPageNumber(1)
  }, [query])

  // Callback increments PageNumber when last element is viewed
  const lastDealElementRef = useCallback(
    node => {
      if (loading) return
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber(prevPageNumber => prevPageNumber + 1)
        }
      })
      if (node) observer.current.observe(node)
    },
    [loading, hasMore]
  )

  useEffect(() => {
    fetchWalletAction()(authAxios, financierDispatch)
  }, [])

  // Show when No deals are available
  useEffect(() => {
    setNoDealsCurrently(deals?.length === 0 && !loading)
  }, [deals, loading])

  return financierState?.financier ? (
    <div className={styles.dealsPage}>
      <div className={styles.welcomeUser}>
        <Text size='1.3' color='#566573'>
          {`Welcome, `}
        </Text>
        <Text size='1.45' color='#333333' bold cursive>
          {financierState?.financier?.financierName} ! 👋
        </Text>
      </div>
      {/* <LiquidationPolicy /> */}
      {noDealsCurrently ? (
        <NoDealsInfo
          header='No Active Deals found'
          description='More deals are in approval queue. Please try again in a while.'
        />
      ) : (
        <>
          <div className={styles.deals}>
            {deals.map((item, index) => {
              if (deals?.length === index + 1) {
                return <Deal className={styles.deal} key={item.id} innerRef={lastDealElementRef} deal={item} />
              } else {
                return <Deal className={styles.deal} key={item.id} deal={item} />
              }
            })}
          </div>
          <div>{loading && <LoadingIndicator />}</div>
          <div>{error && <Text>{error}</Text>}</div>
        </>
      )}
    </div>
  ) : (
    <LoadingIndicator />
  )
}
